// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aad9a673","239":"65f3173b","282":"39344434","453":"ab85727e","622":"8b6dad78","667":"1922b405","879":"859c2369"}[chunkId] + ".chunk.js";
};